import { h } from "snabbdom";
import { ELEMENT_TYPE } from "./constants";
import {
  SlateEditor,
  SlateElement,
  SlateTransforms,
  DomEditor,
} from "@wangeditor/editor";
import DeleteIcon from "@saas/components/assets/images/wang-editor/delete.png";
import { Editor, Transforms } from "slate";
// 渲染节点
/**
 * @param elem 标记块元素
 * @param children 元素子节点
 * @param editor 编辑器实例
 * @returns vnode 节点（通过 snabbdom.js 的 h 函数生成）
 */
const renderToELem = (elem, children, editor) => {
  const qChild = children[0];
  const aChild = children[1];
  const path = DomEditor.findPath(editor, elem);
  const isDisablsed = editor.isDisabled();
  // 删除按钮
  const deleteVnode = h(
    // HTML tag
    "img",
    // HTML 属性、样式、事件
    {
      key: new Date().getTime(),
      attrs: {
        class: "delete-icon",
      },
      props: {
        src: DeleteIcon,
      }, // HTML 属性，驼峰式写法
      style: {
        width: "16px",
        height: "16px",
        minHeight: "16px",
        minWidth: "16px",
        lineHeight: "24px",
        textAlign: "center",
        cursor: "pointer",
        position: "absolute",
        top: "4px",
        right: "4px",
      }, // HTML style ，驼峰式写法
      on: {
        click: () => {
          // 删除当前节点
          SlateTransforms.removeNodes(editor, {
            at: path,
            mode: "highest",
          });
        },
      },
    }
  );
  const qTitleVnode = h(
    // HTML tag
    "span",
    // HTML 属性、样式、事件
    {
      key: new Date().getTime(),
      props: { contentEditable: false }, // HTML 属性，驼峰式写法
      style: {
        width: "24px",
        height: "24px",
        lineHeight: "24px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "6px",
        border: "1px solid #F2F3F5",
        textAlign: "center",
        fontWeight: 600,
        background: "#FFFFFF",
        fontSize: "11px",
        color: "#4E5969",
      },
    },
    "问"
  );
  const qContentVnode = h(
    // HTML tag
    "div",
    // HTML 属性、样式、事件
    {
      key: new Date().getTime(),
      props: { contentEditable: !isDisablsed }, // HTML 属性，驼峰式写法
      attrs: {
        class: "q-block-content",
      },
      style: {
        flex: 1,
        minHeight: "24px",
        lineHeight: "24px",
        display: "inline-block",
        margin: "0 4px",
      },
    },
    qChild
  );
  const aTitleVnode = h(
    // HTML tag
    "span",
    // HTML 属性、样式、事件
    {
      key: new Date().getTime(),
      props: { contentEditable: false }, // HTML 属性，驼峰式写法
      style: {
        width: "24px",
        height: "24px",
        lineHeight: "24px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "6px",
        border: "1px solid #F2F3F5",
        background: "#FFFFFF",
        textAlign: "center",
        fontWeight: 600,
        fontSize: "11px",
        color: "#00C89D",
      },
    },
    "答"
  );
  const aContentVnode = h(
    // HTML tag
    "div",
    // HTML 属性、样式、事件
    {
      key: new Date().getTime(),
      props: { contentEditable: !isDisablsed }, // HTML 属性，驼峰式写法
      attrs: {
        class: "a-block-content",
      },
      style: {
        flex: 1,
        minHeight: "24px",
        lineHeight: "24px",
        display: "inline-block",
        margin: "0 4px",
      },
    },
    aChild
  );
  const qVnode = h(
    // HTML tag
    "div",
    // HTML 属性、样式、事件
    {
      key: new Date().getTime(),
      props: { contentEditable: !isDisablsed }, // HTML 属性，驼峰式写法
      style: {
        width: "100%",
        minHeight: "24px",
        display: "flex",
        position: "relative",
        paddingRight: "24px",
      },
      attrs: {
        class: "q-block",
      },
    },
    [qTitleVnode, qContentVnode, deleteVnode]
  );
  const aVnode = h(
    // HTML tag
    "div",
    // HTML 属性、样式、事件
    {
      key: new Date().getTime(),
      props: { contentEditable: !isDisablsed }, // HTML 属性，驼峰式写法
      style: {
        width: "100%",
        minHeight: "24px",
        display: "flex",
        marginTop: "6px",
      },
      attrs: {
        class: "a-block",
      },
    },
    [aTitleVnode, aContentVnode]
  );

  const vnode = h(
    ELEMENT_TYPE,
    {
      key: new Date().getTime(),
      props: {
        contentEditable: !isDisablsed,
      },
      attrs: {
        "data-w-e-type": ELEMENT_TYPE,
        class: "qa-block",
      },
      style: {
        width: "100%",
        maxWidth: "360px",
        minHeight: "60px",
        display: "block",
      },
    },
    [qVnode, aVnode]
  );
  // 光标移到当前节点的第一个字符
  return vnode;
};

// 编辑器渲染配置
export const renderToElemConfig = {
  type: ELEMENT_TYPE,
  renderElem: renderToELem,
};
